import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, inject } from '@angular/core';
import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective } from 'mbs-ui-kit';
import { AgentType } from 'mbs-ui-shared@models/Computer';
import { PermissionsEnum } from 'mbs-ui-shared@models/PermissionsEnum';
import { of } from 'rxjs';
import { SmartSearchBaseTemplateComponent } from './smart-search-base-template.component';

@Component({
  selector: 'mbs-smart-search-agent-template',
  templateUrl: './smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchAgentTemplateComponent) }],
  imports: [CommonModule]
})
export class SmartSearchAgentTemplateComponent extends SmartSearchBaseTemplateComponent {
  i18nPipe: I18NextPipe;
  private ability = inject(AbilityService);

  public tag = 'Agent';
  public filterPropertyName = 'displayValue';
  constructor() {
    const i18nPipe = inject(I18NextPipe);

    super();

    this.i18nPipe = i18nPipe;
  }
  public items = () => {
    const agentTypes = [AgentType.Backup, AgentType.RMM, AgentType.RA];

    if (this.ability.can('read', PermissionsEnum.ShowDeepInstinctProvider)) {
      agentTypes.push(AgentType.DeepInst);
    }

    return of(
      agentTypes.map((value) => ({
        value,
        searchText: value,
        displayValue: this.i18nPipe.transform(`shared:products.${value}`),
        translation: `shared:products.${value}`
      }))
    );
  };
}
